// ✅ redux/states/categories/thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

/* -------------------- GET ALL CATEGORIES -------------------- */
export const AllCategoryThunk = createAsyncThunk(
  "categories/AllCategoryThunk",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/categories/list`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch categories"
      );
    }
  }
);

/* -------------------- GET SINGLE CATEGORY -------------------- */
export const GetSingleCategoryThunk = createAsyncThunk(
  "categories/GetSingleCategoryThunk",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/categories/show?uuid=${uuid}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch category details"
      );
    }
  }
);

/* -------------------- ADD CATEGORY -------------------- */
export const AddCategoryThunk = createAsyncThunk(
  "categories/AddCategoryThunk",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/categories/add`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to add category");
    }
  }
);

/* -------------------- UPDATE CATEGORY -------------------- */
export const UpdateCategoryThunk = createAsyncThunk(
  "categories/UpdateCategoryThunk",
  async ({ uuid, formData }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/categories/update`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to update category"
      );
    }
  }
);

/* -------------------- DELETE CATEGORY -------------------- */
export const DeleteCategoryThunk = createAsyncThunk(
  "categories/DeleteCategoryThunk",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/categories/delete?uuid=${uuid}`);
      return {
        uuid,
        message: response.data?.message || "Category deleted successfully",
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to delete category"
      );
    }
  }
);




/* --------------------------------------- */
/* -------------------- GET ALL SUB-CATEGORIES -------------------- */
/* ---------------------------------------- */


/* -------------------- GET ALL SUB-CATEGORIES -------------------- */
export const AllSubCategoryThunk = createAsyncThunk(
  "categories/AllSubCategoryThunk",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/subcategories/list`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch categories"
      );
    }
  }
);

/* -------------------- GET SINGLE SUB-CATEGORIES -------------------- */
export const GetSingleSubCategoryThunk = createAsyncThunk(
  "categories/GetSingleSubCategoryThunk",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/subcategories/show?uuid=${uuid}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to fetch category details"
      );
    }
  }
);

/* -------------------- ADD SUB-CATEGORIES -------------------- */
export const AddSubCategoryThunk = createAsyncThunk(
  "categories/AddSubCategoryThunk",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/subcategories/add`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to add category");
    }
  }
);

/* -------------------- UPDATE SUB-CATEGORIES -------------------- */
export const UpdateSubCategoryThunk = createAsyncThunk(
  "categories/UpdateSubCategoryThunk",
  async ({ uuid, formData }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`/api/subcategories/update`, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to update category"
      );
    }
  }
);

/* -------------------- DELETE SUB-CATEGORIES -------------------- */
export const DeleteSubCategoryThunk = createAsyncThunk(
  "categories/DeleteSubCategoryThunk",
  async (uuid, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `/api/subcategories/delete?uuid=${uuid}`
      );
      return {
        uuid,
        message: response.data?.message || "Category deleted successfully",
      };
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to delete category"
      );
    }
  }
);
